export enum RegionsEnum {
  StavropolKrai = 'stavropol',
  KarachayCherkessRepublic = 'karachay-cherkess',
  KabardinoBalkarianRepublic = 'kabardino-balkarian',
  RepublicOfNorthOssetiaAlania = 'alania',
  IngushetiaRepublic = 'ingushetiya',
  ChechenRepublic = 'chechen',
  DagestanRepublic = 'dagestan',
}
